import { Fetch } from "../utils/fetch";
/**
 * Sample操作封装
 */
export class MarketReportFileApi {
  /**
   * 保存数据
   * @param {SampleForm} data 保存数据对象
   */
  getByPage(data) {
    return Fetch.fetch({
      url: "MarketReportFile/GetByPage",
      method: "get",
      params: data
    });
  }
  //   getReportTypeById(data) {
  //     return Fetch.fetch({
  //       url: "MarketReportType/GetReportTypeById",
  //       method: "get",
  //       params: data
  //     });
  //   }
  insertReportFile(data) {
    return Fetch.fetch({
      url: "MarketReportFile/InsertReportFile",
      method: "post",
      data: data
    });
  }
  insertReportFileNew(data) {
    return Fetch.fetch({
      url: "MarketReportFile/InsertReportFileNew",
      method: "post",
      data: data
    });
  }
  updateMarketReportFile(data) {
    return Fetch.fetch({
      url: "MarketReportFile/UpdateMarketReportFile",
      method: "put",
      data: data
    });
  }
  updateMarketReportFileNew(data) {
    return Fetch.fetch({
      url: "MarketReportFile/UpdateMarketReportFileNew",
      method: "post",
      data: data
    });
  }
  deleteReportFile(data) {
    return Fetch.fetch({
      url: "MarketReportFile/DeleteReportFile",
      method: "delete",
      params: data
    });
  }
  /**
   * 获取临时stsToken
   * @export
   * @param {any} data
   */
  getStsToken(data) {
    return Fetch.fetch({
      url: "Token/GetStsToken",
      method: "get",
      params: data
    });
  }
}
